<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main style="padding-top: 0rem">
      <div class="zj-layout-main-content scrollable">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="16rem"
        >
          <el-form-item
            label="任务名称"
            prop="TaskTiltle"
            style="display: inline-block"
          >
            <el-input
              v-model="ruleForm.TaskTiltle"
              style="width: 40rem"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" style="display: inline-block">
            <el-select
              style="width: 40rem"
              v-model="ruleForm.ChargerId"
              v-bind:disabled="IsEdit"
              @change="handleCheckedChange"
            >
              <el-option-group
                v-for="group in UsersOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" style="display: inline-block">
            <el-input
              style="width: 40rem"
              v-model="ruleForm.Phone"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="计划响应时间" style="display: inline-block">
            <el-input-number
              :min="1"
              style="width: 35rem"
              v-model="ruleForm.PlanResponseTime"
              controls-position="right"
              v-bind:disabled="IsEdit"
            ></el-input-number>
            <div style="display: inline-block; padding-left: 1.5rem">分钟</div>
          </el-form-item>
          <el-form-item
            label="任务描述"
            style="display: inline-block"
            prop="TaskDesc"
          >
            <el-input
              type="textarea"
              style="width: 98rem"
              v-model="ruleForm.TaskDesc"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="任务地址" style="display: inline-block">
            <el-input
              style="width: 98rem"
              v-model="ruleForm.Location"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="经度"
            prop="Longitude"
            style="display: inline-block"
          >
            <el-input
              v-model="ruleForm.Longitude"
              style="width: 40rem"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="纬度"
            prop="Latitude"
            style="display: inline-block"
          >
            <el-input
              v-model="ruleForm.Latitude"
              style="width: 35rem"
              v-bind:disabled="IsEdit"
            ></el-input>
            <ZjLngLatSelect
              :point_lat="ruleForm.Latitude"
              :point_lng="ruleForm.Longitude"
              @onGotLngLat="onGotLngLat"
              :disabled="IsEdit"
              style="margin-left: 0.5rem"
            ></ZjLngLatSelect>
          </el-form-item>
          <el-form-item label="任务执行方式" style="display: inline-block">
            <el-radio-group
              v-model="ruleForm.ExecWay"
              style="width: 98rem"
              v-bind:disabled="IsEdit"
            >
              <el-radio
                v-for="item in ExecWayoptions"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="任务设置">
            <div
              class="bgcolor"
              style="padding: 1rem 1rem; width: 98rem; height: 60rem"
            >
              <el-tabs class="task" v-model="activeName">
                <el-tab-pane
                  :key="item.name"
                  v-for="item in EmergencyTaskType"
                  :label="item.Description"
                  :name="item.ItemKey"
                >
                  <CommunicationSettingInfo
                    v-if="item.ItemKey == 'EmergencyTaskType-01'"
                    :ref="item.ItemKey"
                    :PlanTaskId="ruleForm.TaskId"
                  />
                  <ComponentResourcesInfo
                    v-if="item.ItemKey == 'EmergencyTaskType-02'"
                    :ref="item.ItemKey"
                    :PlanTaskId="ruleForm.TaskId"
                  />
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer style="padding-bottom: 0rem">
      <div
        class="right"
        style="width: 134rem; text-align: center; padding: 0rem 0rem"
      >
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-show="IsEdit == false"
          >提交</el-button
        >
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import CommunicationSettingInfo from "./CommunicationSettingInfo";
import ComponentResourcesInfo from "./ResourcesSettingInfo";
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjPlanTaskinfo",
  controller: "UI",
  action: "PlanTaskinfo",
  components: {
    CommunicationSettingInfo: CommunicationSettingInfo,
    ComponentResourcesInfo: ComponentResourcesInfo,
  },
  props: {
    PPlanId: String,
    TaskId: String,
    IsEditTask: String,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      UsersOptions: [],
      ChildUser: [],
      activeName: "",
      EmergencyTaskType: [],
      ExecWayoptions: [
        { value: "1", label: "自动执行" },
        { value: "2", label: "人工启动" },
      ],
      ruleForm: {
        OrgId: this.user.Departments[0].OrgId,
        TaskId: this.$props.TaskId.TaskId, //todo 生成Guid
        PlanId: this.$props.PPlanId,
        TaskTypeId: 0,
        TaskTiltle: "",
        TaskDesc: "",
        ChargerName: "",
        ChargerId: "",
        Phone: "",
        PlanResponseTime: 1,
        ExecWay: "1",
        Location: "",
        Longitude: 0,
        Latitude: 0,
        OrderNo: 0,
      },
      IsEdit: false,
      rules: {
        TaskTiltle: [{ required: true, message: "请输入任务名称" }],
        TaskDesc: [{ required: true, message: "请输入任务描述" }],
      },
    };
  },
  created: function () {
    this.loading = true;
    this.loadingText = "加载中...";
    utils
      .waitAll([
        this.config.getUValue("EmergencyService:PersonOrgianiztionType:", ""),
        this.config.getUValue("EmergencyService:EmergencyTaskType:", ""),
        new MyApis.AddressbookApi().FindByConditions({}),
      ])
      .then((r) => {
        this.GetUserData(r[0].JValue, r[2].data.Data);
        let data = r[1].JValue;
        if (data) {
          this.activeName = data[0].ItemKey;
          this.EmergencyTaskType = data;
        }
        this.loading = false;
        this.search();
        return r;
      })
      .catch((e) => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    this.IsEdit = this.$props.IsEditTask;
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    GetUserData(Fatoption, Chiloption) {
      this.ChildUser = Chiloption;
      var userOpt = [];
      for (var i = 0; i < Fatoption.length; i++) {
        var item = Fatoption[i];
        var users = [];
        for (var j = 0; j < Chiloption.length; j++) {
          var user = Chiloption[j];
          if (user.ResourceTypeId == item.ItemKey) {
            users.push({ value: user.BookId, label: user.PersonName });
          }
        }
        userOpt.push({
          label: item.Extend1,
          options: users,
        });
      }
      this.UsersOptions = userOpt;
    },
    handleCheckedChange(value) {
      for (var j = 0; j < this.ChildUser.length; j++) {
        var user = this.ChildUser[j];
        if (user.BookId == value) {
          this.ruleForm.ChargerName = user.PersonName;
          this.ruleForm.Phone = user.PhoneNum;
          break;
        }
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    search() {
      let objId = this.$props.TaskId.TaskId;
      if (objId != "" || objId != undefined) {
        let searchInfo = {
          TaskId: objId,
          PageSize: 10000,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
        this.loading = true;
        this.loadingText = "加载中...";
        new MyApis.PlanTaskApi()
          .GetItemById(searchInfo)
          .then((r) => {
            var data = r.data.Data;
            if (data) {
              this.ruleForm = data;
              this.activeName = this.getActiveName(this.ruleForm.TaskTypeId);
              //获取任务配合组件的data
            }
            //var total = data.BaseSearch.TotalCount;
            //this.ruleForm.OrderNo = total + 1;
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    submit() {
      var actobj = this.$refs[this.activeName][0];
      var childactname = actobj.activeName;
      var childobj = actobj.$refs[childactname][0];
      var tasksettingDto = [];
      var taskinfo = childobj.Gettaskreceiver(); //获取短信发送人的userid以及内容
      tasksettingDto.push(taskinfo);

      var plantask = {};
      this.ruleForm.Longitude = parseFloat(this.ruleForm.Longitude);
      this.ruleForm.Latitude = parseFloat(this.ruleForm.Latitude);
      this.ruleForm.TaskTypeId = this.getTaskTypeId;
      plantask.PlanTaskDTO = this.ruleForm;
      plantask.TaskSettingTransactionDTO = tasksettingDto;

      this.loading = true;
      this.loadingText = "提交中...";
      new MyApis.PlanTaskApi()
        .UpdateTaskTransaction(plantask)
        .then((r) => {
          r = r.data.Data;
          this.$emit("backList", {});
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    onBack() {
      this.$emit("backList", {});
    },
    getActiveName(taskTypeId) {
      var result = "EmergencyTaskType-01";
      switch (taskTypeId) {
        case 1:
          result = "EmergencyTaskType-01";
          break;
        case 2:
          result = "EmergencyTaskType-02";
          break;
        default:
          result = "EmergencyTaskType-01";
          break;
      }
      return result;
    },
  },
  computed: {
    getTaskTypeId() {
      var result = 0;
      switch (this.activeName) {
        case "EmergencyTaskType-01":
          result = 1;
          break;
        case "EmergencyTaskType-02":
          result = 2;
          break;
        default:
          break;
      }
      return result;
    },
  },
};
</script>
